module.exports = __webpack_public_path__ + "img/default_img.f4f8dd9c.png";